export default {"src":"/_next/static/media/ic-close.8c3de6c0.svg","height":32,"width":32};